var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "display-config" }, [
    _c("div", { staticClass: "d-flex flex-column" }, [
      _c("h2", [_vm._v(_vm._s(_vm.$t("fastWizard.customizeLiveChat")))]),
      _vm._v(" "),
      _c("span", [
        _vm._v(_vm._s(_vm.$t("fastWizard.createBrandedExperience"))),
      ]),
      _vm._v(" "),
      _c("h4", { staticClass: "mt-2" }, [
        _vm._v(_vm._s(_vm.$t("fastWizard.chatColor"))),
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("fastWizard.chooseChatColor")))]),
      _vm._v(" "),
      _c("div", { staticClass: "colorPalette" }, [
        _c(
          "div",
          {
            staticClass: "palette servquick",
            on: {
              click: function ($event) {
                return _vm.changeTheme("servquick")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(
                      _vm.settings,
                      "chatCustomizationSettings.preferredThemeColor"
                    ) === "servquick"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "palette mango",
            on: {
              click: function ($event) {
                return _vm.changeTheme("mango")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(
                      _vm.settings,
                      "chatCustomizationSettings.preferredThemeColor"
                    ) === "mango"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "palette blue",
            on: {
              click: function ($event) {
                return _vm.changeTheme("blue")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(
                      _vm.settings,
                      "chatCustomizationSettings.preferredThemeColor"
                    ) === "blue"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "palette purple",
            on: {
              click: function ($event) {
                return _vm.changeTheme("purple")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(
                      _vm.settings,
                      "chatCustomizationSettings.preferredThemeColor"
                    ) === "purple"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "palette pink",
            on: {
              click: function ($event) {
                return _vm.changeTheme("pink")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(
                      _vm.settings,
                      "chatCustomizationSettings.preferredThemeColor"
                    ) === "pink"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "palette green",
            on: {
              click: function ($event) {
                return _vm.changeTheme("green")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(
                      _vm.settings,
                      "chatCustomizationSettings.preferredThemeColor"
                    ) === "green"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "palette red",
            on: {
              click: function ($event) {
                return _vm.changeTheme("red")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(
                      _vm.settings,
                      "chatCustomizationSettings.preferredThemeColor"
                    ) === "red"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "palette orange",
            on: {
              click: function ($event) {
                return _vm.changeTheme("orange")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(
                      _vm.settings,
                      "chatCustomizationSettings.preferredThemeColor"
                    ) === "orange"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "palette yellow",
            on: {
              click: function ($event) {
                return _vm.changeTheme("yellow")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(
                      _vm.settings,
                      "chatCustomizationSettings.preferredThemeColor"
                    ) === "yellow"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "palette black",
            on: {
              click: function ($event) {
                return _vm.changeTheme("black")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(
                      _vm.settings,
                      "chatCustomizationSettings.preferredThemeColor"
                    ) === "black"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("h4", { staticClass: "mt-2" }, [
        _vm._v(_vm._s(_vm.$t("fastWizard.chatBubble"))),
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("fastWizard.selectBubble")))]),
      _vm._v(" "),
      _c("div", { staticClass: "bubble-palette" }, [
        _c(
          "span",
          {
            staticClass: "bubble-item",
            on: {
              click: function () {
                return _vm.changeBubbleWithIndex("1")
              },
            },
          },
          [_c("Bubble1")],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "bubble-item",
            on: {
              click: function () {
                return _vm.changeBubbleWithIndex("2")
              },
            },
          },
          [_c("Bubble2")],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "bubble-item",
            on: {
              click: function () {
                return _vm.changeBubbleWithIndex("3")
              },
            },
          },
          [_c("Bubble3")],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "bubble-item",
            on: {
              click: function () {
                return _vm.changeBubbleWithIndex("4")
              },
            },
          },
          [_c("Bubble4")],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "bubble-item",
            on: {
              click: function () {
                return _vm.changeBubbleWithIndex("5")
              },
            },
          },
          [_c("Bubble5")],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "bubble-item",
            on: {
              click: function () {
                return _vm.changeBubbleWithIndex("6")
              },
            },
          },
          [_c("Bubble6")],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "bubble-item",
            on: {
              click: function () {
                return _vm.changeBubbleWithIndex("7")
              },
            },
          },
          [_c("Bubble7")],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "bubble-item",
            on: {
              click: function () {
                return _vm.changeBubbleWithIndex("8")
              },
            },
          },
          [_c("Bubble8")],
          1
        ),
      ]),
      _vm._v(" "),
      _c("h4", { staticClass: "mt-2" }, [
        _vm._v(_vm._s(_vm.$t("fastWizard.chatBubbleColor"))),
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("fastWizard.selectChatBubbleColor")))]),
      _vm._v(" "),
      _c("div", { staticClass: "bubbleColorPalette" }, [
        _c(
          "div",
          {
            staticClass: "palette blue",
            on: {
              click: function ($event) {
                return _vm.changeBubbleColor("#0cbaba")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(_vm.settings, "bubble.bubbleColor") === "#0cbaba"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "palette purple",
            on: {
              click: function ($event) {
                return _vm.changeBubbleColor("#2b004a")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(_vm.settings, "bubble.bubbleColor") === "#2b004a"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "palette pink",
            on: {
              click: function ($event) {
                return _vm.changeBubbleColor("#b3004d")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(_vm.settings, "bubble.bubbleColor") === "#b3004d"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "palette green",
            on: {
              click: function ($event) {
                return _vm.changeBubbleColor("#006319")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(_vm.settings, "bubble.bubbleColor") === "#006319"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "palette red",
            on: {
              click: function ($event) {
                return _vm.changeBubbleColor("#910704")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(_vm.settings, "bubble.bubbleColor") === "#910704"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "palette orange",
            on: {
              click: function ($event) {
                return _vm.changeBubbleColor("#eea849")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(_vm.settings, "bubble.bubbleColor") === "#eea849"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "palette yellow",
            on: {
              click: function ($event) {
                return _vm.changeBubbleColor("#a3a007")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(_vm.settings, "bubble.bubbleColor") === "#a3a007"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "palette black",
            on: {
              click: function ($event) {
                return _vm.changeBubbleColor("#0d2226")
              },
            },
          },
          [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$_.get(_vm.settings, "bubble.bubbleColor") === "#0d2226"
                      ? "✓"
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "picker" },
          [
            _vm._v(
              "\n                " +
                _vm._s(
                  [
                    "#0cbaba",
                    "#2b004a",
                    "#b3004d",
                    "#006319",
                    "#910704",
                    "#eea849",
                    "#a3a007",
                    "#0d2226",
                  ].includes(_vm.bubbleColor)
                    ? _vm.$t("fastWizard.customSelection")
                    : "✓ " + _vm.$t("fastWizard.customSelection")
                ) +
                "\n                "
            ),
            _c("color-picker", {
              staticClass: "bubbleColorInput",
              attrs: { position: { left: 0, top: "-400px" } },
              model: {
                value: _vm.picker,
                callback: function ($$v) {
                  _vm.picker = $$v
                },
                expression: "picker",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "preview ml-5" }, [_c("LivePreview")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }